












// 底部标签
import Tabbar from '@/components/tabbar/tabbar.vue'
import loading from '@/components/loading.vue'
import toast from '@/components/toast.vue'
import { getOperId, postAppId, employeesList } from './api/api.config'
import { Component, Vue, Watch } from 'vue-property-decorator'
@Component({
  components: {
    loading,
    toast,
    Tabbar,
  },
})
export default class App extends Vue {
  $route: any
  @Watch('$route')
  change() {
    if (this.$route.query.channelCode) {
      localStorage.setItem('channeObj', JSON.stringify(this.$route.query))
    }
    console.log(this.$route.path,'this.$route.path')
    if (this.$route.path === '/sgs') {
      return
    }else if (this.$route.path === '/bari'){
      return
    }else {
      // if (localStorage.getItem('openId')) {
      //   return
      // } else {
      //   const href = window.location.href
      //   const str = href.substr(href.indexOf('?') + 1, href.length)
      //   const params = str.split('&')
      //   const code = params[0].split('=')[1]
      //   if (code) {
      //     getOperId(code).then((res) => {
      //       localStorage.setItem('openId', res.data.openId)
      //     })
      //   } else {
      //     var local = 'https://www.evweilan.com'
      //     // var local = 'http://dev.lemonstea.com'
      //     window.location.href =
      //       `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxce9bde39a0fe5e00&redirect_uri=` +
      //       encodeURIComponent(local) +
      //       `&response_type=code&scope=snsapi_base&state=state#wechat_redirect`
      //   }
      // }
    }
  }
  mounted() {
    this.employeesList()
  }
  async employeesList() {
    let result = await employeesList()
  }
}
